module.exports = __webpack_public_path__ + "static/img/designer1.720807d5.png";